import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const mapSettingsColumnsFilterSelector = (state: AppState) => state.map.mapSettings.data.toolsState.columnsFilter;
export const useMapSettingsColumnsFilterSelector = () => useSelector(mapSettingsColumnsFilterSelector);
